addEventListener("DOMContentLoaded", () => {
    const dvModal = new DvModal();
    dvModal.init();
    window.dvModal = dvModal;
    const showHtml = dvModal.events.html;
    let ticketSaving = false;
    const onClick = dvModal.onClick.bind(dvModal);
    dvModal.onClick = (trigger) => {
        if (ticketSaving || window.FullioArrivalReceipt?.modalSavingLineId || window.FullioArrivalProductPicker?.isSaving()) return Promise.resolve();
        dvModal.arrivalReceiptLineId = trigger.closest('article[id^="arrival-receipt-line-"]')?.id.replace('arrival-receipt-line-', '') || null;
        return onClick(trigger);
    };
    const onPageFormSubmit = dvModal.onPageFormSubmit.bind(dvModal);
    dvModal.onPageFormSubmit = (form, event, confirmEl) => {
        if (window.FullioArrivalProductPicker?.isSaving()) return Promise.resolve();
        dvModal.arrivalReceiptLineId = null;
        return onPageFormSubmit(form, event, confirmEl);
    };
    dvModal.modalEl.addEventListener('hide.bs.modal', (event) => {
        if (window.FullioArrivalProductPicker?.isSaving()) {
            event.preventDefault();
            return;
        }
        window.FullioArrivalProductPicker?.dispose();
    });
    const onFormSubmit = dvModal.onFormSubmit.bind(dvModal);
    dvModal.onFormSubmit = async (form, event) => {
        if (form.matches('[data-arrival-product-picker]')) {
            await window.FullioArrivalProductPicker.submit(event);
            return;
        }
        if (form.matches('[data-ticket-create-form]')) {
            if (ticketSaving || window.FullioArrivalReceipt?.modalSavingLineId || !form.reportValidity()) return;
            const data = new FormData(form);
            if (event.submitter?.name) data.append(event.submitter.name, event.submitter.value);
            const buttons = Array.from(form.querySelectorAll('button, input[type="submit"]'));
            const disabledStates = buttons.map(button => [button, button.disabled]);
            const errors = form.querySelector('[data-ticket-create-errors]');
            const showErrors = (messages) => {
                errors.replaceChildren();
                messages.forEach(message => {
                    const paragraph = document.createElement('div');
                    paragraph.textContent = message;
                    errors.appendChild(paragraph);
                });
                errors.classList.remove('d-none');
            };
            errors.replaceChildren();
            errors.classList.add('d-none');
            ticketSaving = true;
            if (window.FullioArrivalReceipt) window.FullioArrivalReceipt.modalSavingLineId = 'ticket-create';
            buttons.forEach(button => { button.disabled = true; });
            try {
                const response = await fetch(form.action, {
                    method: form.method.toUpperCase(),
                    body: data,
                    headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'},
                    redirect: 'error'
                });
                if ((!response.ok && response.status !== 422) || !response.headers.get('content-type')?.includes('application/json')) throw new Error('Unexpected response');
                const payload = await response.json();
                if (response.status === 422 && Array.isArray(payload.errors) && payload.errors.length && payload.errors.every(message => typeof message === 'string' && message.trim())) {
                    showErrors(payload.errors);
                    return;
                }
                const tickets = document.querySelector('[data-arrival-tickets]');
                if (!response.ok || payload.result !== 'html' || typeof payload.html !== 'string' || typeof payload.arrival_tickets !== 'string' || !tickets) throw new Error('Unexpected ticket result');
                tickets.innerHTML = payload.arrival_tickets;
                showHtml(payload);
            } catch (error) {
                showErrors(['Не удалось получить результат создания тикета. Введённые данные сохранены. Проверьте соединение и список тикетов перед повторной попыткой.']);
            } finally {
                ticketSaving = false;
                if (window.FullioArrivalReceipt) window.FullioArrivalReceipt.modalSavingLineId = null;
                disabledStates.forEach(([button, disabled]) => {
                    if (button.isConnected) button.disabled = disabled;
                });
            }
            return;
        }
        if (window.FullioArrivalReceipt) window.FullioArrivalReceipt.modalSavingLineId = dvModal.arrivalReceiptLineId;
        try {
            await onFormSubmit(form, event);
        } finally {
            if (window.FullioArrivalReceipt) window.FullioArrivalReceipt.modalSavingLineId = null;
        }
    };
    dvModal.on('html', (response) => {
        if (response.arrival_receipt_line) {
            window.FullioArrivalReceipt.replaceLine(response.arrival_receipt_line, {preserveDraft: true, expectedId: dvModal.arrivalReceiptLineId});
        }
        showHtml(response);
        window.FullioArrivalProductPicker?.mount(dvModal);
    });
});
